// extracted by mini-css-extract-plugin
export default {"mainInfo":"MainBalance_mainInfo__BzvzT","mainInfoBlock":"MainBalance_mainInfoBlock__IuurY","blockTitle":"MainBalance_blockTitle__453FG"};